import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ServiceResumoDesk } from "@/services/serviceResumoDesk";
//import { PlusSquare } from "lucide-react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export function Notas() {
  const { t } = useTranslation(["translation", "common"]);
  const [openAdd, setOpenAdd] = useState(false);
  const [novaNota, setNovaNota] = useState({ title: "", description: "" });
  const [page, setPage] = useState(1);
  const perPage = 10;

  const {
    data: notasData,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["notas", page],
    queryFn: async () => {
      const res = await ServiceResumoDesk.getAllNotas(page, perPage);
      return res?.data || { data: [], qtdRegistros: 0 };
    },
  });

  const notasList = notasData?.data || [];
  const totalNotas = notasData?.qtdRegistros || 0;

  const handleAddNota = async (e: any) => {
    e.preventDefault();
    if (!novaNota.title) {
      toast.error(t("notesModule.errors.title_required"));
      return;
    }
    try {
      const res = await ServiceResumoDesk.addNotas(novaNota);
      if (res.status === 200) {
        setNovaNota({ title: "", description: "" });
        setOpenAdd(false);
        setPage(1);
        refetch();
      }
    } catch (e) {
      toast.error(t("notesModule.errors.add"));
    }
  };

  return (
    <div>
      <div className="flex items-center gap-3 mb-2">
        <span className="text-xl font-medium">{t("notesModule.title")}</span>
        {/*  <button type="button" onClick={() => setOpenAdd(true)}>
          <PlusSquare size={20} color="#153DCE" />
        </button> */}
      </div>
      {openAdd && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <form
            onSubmit={handleAddNota}
            className="bg-white w-full max-w-md p-6 rounded-xl shadow-lg relative"
            style={{ minWidth: 320 }}
          >
            <button
              type="button"
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-xl"
              onClick={() => {
                setOpenAdd(false);
                setNovaNota({ title: "", description: "" });
              }}
              aria-label="Fechar modal"
            >
              ×
            </button>
            <h2 className="text-lg font-semibold mb-4">
              {t("notesModule.modal.title")}
            </h2>
            <input
              className="border px-2 py-1 rounded w-full mb-2"
              placeholder={t("notesModule.form.title.placeholder")}
              value={novaNota.title}
              onChange={(e) =>
                setNovaNota({ ...novaNota, title: e.target.value })
              }
              required
              autoFocus
            />
            <textarea
              className="border px-2 py-1 rounded w-full mb-2 resize-none"
              placeholder={t("notesModule.form.description.placeholder")}
              value={novaNota.description}
              onChange={(e) =>
                setNovaNota({ ...novaNota, description: e.target.value })
              }
              rows={4}
            />
            <div className="flex gap-2 justify-end mt-2">
              <button
                type="button"
                className="bg-gray-300 px-3 py-1 rounded"
                onClick={() => {
                  setOpenAdd(false);
                  setNovaNota({ title: "", description: "" });
                }}
              >
                {t("common:cancel")}
              </button>
              <button
                type="submit"
                className="bg-azul-400 text-white px-3 py-1 rounded"
              >
                {t("common:save")}
              </button>
            </div>
          </form>
        </div>
      )}
      {isLoading ? (
        <div>{t("common:loading")}</div>
      ) : notasList.length === 0 ? (
        <span className="block text-center text-sm">
          {t("notesModule.empty")}
        </span>
      ) : (
        <>
          <div className="space-y-2">
            {notasList.map((nota: any) => (
              <div
                key={nota.id}
                className="bg-cinza-100 px-3 py-2 rounded-lg relative"
              >
                <span className="font-medium text-xs text-white px-2 rounded-xl absolute -top-2 right-0 bg-azul-400">
                  {nota?.id_desk
                    ? t("notesModule.type.desk")
                    : nota?.id_prospecting
                      ? t("notesModule.type.prospecting")
                      : nota?.id_reunion
                        ? t("notesModule.type.meeting")
                        : t("notesModule.type.none")}
                </span>
                <h3 className="font-medium text-base">{nota.title}</h3>
                <a
                  href={`/desks/${nota.id_desk}`}
                  target="_blank"
                  className="font-medium text-xs text-azul-400"
                >
                  {nota?.desks?.name ??
                    nota.prospecting?.name ??
                    nota.reunion?.name ??
                    "-"}
                </a>
                <p className="text-xs text-gray-600 line-clamp-4">
                  {nota.description}
                </p>
              </div>
            ))}
          </div>
          <div className="flex justify-center gap-2 mt-4">
            <button
              className="px-3 py-1 rounded bg-gray-200 disabled:opacity-50"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              {t("notesModule.pagination.prev")}
            </button>
            <span className="px-2 py-1 text-sm">
              {t("notesModule.pagination.page_of", {
                page,
                total: Math.max(1, Math.ceil(totalNotas / perPage)),
              })}
            </span>
            <button
              className="px-3 py-1 rounded bg-gray-200 disabled:opacity-50"
              onClick={() => setPage((p) => p + 1)}
              disabled={page >= Math.ceil(totalNotas / perPage)}
            >
              {t("notesModule.pagination.next")}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
